"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const card_controls_1 = __importDefault(require("./card-controls"));
const card_resize_controls_1 = __importDefault(require("./card-resize-controls"));
require("../../styles/components/grid-layout/card-container.less");
const CardContainer = ({ children, cardId, activeCardId, updateActiveCard, onDeleteCard, onDuplicateCard, disableAddCards }) => {
    const isActiveCard = (0, react_1.useMemo)(() => activeCardId === cardId, [activeCardId, cardId]);
    const handleCardClick = (0, react_1.useCallback)((event) => {
        if (isActiveCard) {
            return;
        }
        updateActiveCard(cardId);
        event.stopPropagation();
    }, [cardId, isActiveCard, updateActiveCard]);
    const preventDrag = (0, react_1.useCallback)((event) => {
        if (!isActiveCard) {
            event.preventDefault();
            event.stopPropagation();
        }
    }, [isActiveCard]);
    return (react_1.default.createElement("div", { onMouseDown: preventDrag, onClick: handleCardClick, key: cardId, className: (0, classnames_1.default)('card-container', { 'is-active': isActiveCard }) },
        isActiveCard
            ? (react_1.default.createElement("div", { className: "item-content" },
                react_1.default.createElement(card_resize_controls_1.default, null),
                react_1.default.createElement(card_controls_1.default, { disableAddCards: disableAddCards, onDeleteCard: onDeleteCard, onDuplicateCard: onDuplicateCard, cardId: activeCardId }))) : null,
        children));
};
exports.default = CardContainer;
//# sourceMappingURL=card-container.js.map